import { LOGOUT } from "./constants";
const handleError = (error, navigate, dispatch) => {
  if (
    error.response &&
    (error.response.status === 400 || error.response.status === 401) &&
    (error.response.data?.msg === "Invalid Token" ||
      error.response.data?.message === "Invalid Token")
  ) {
    dispatch({
      type: LOGOUT,
      payload: {},
    });
    navigate("/login");
  } else {
    console.error("Error occurred:", error);
  }
};

export default handleError;
